export default __webpack_public_path__ + "static/media/dessert-2.df4d533d.jpg";